export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "VehicleModelMasterImportWorker.03b56dfaa1d87fa881ad.worker.js");
}
